export enum Scopes {
  //Account Actions
  A_ACCOUNT_CANCEL = 'a:account:cancel',
  A_ACCOUNT_BLOCK = 'a:account:block',
  A_ACCOUNT_BLOCK_PB = 'a:account:block_pb',
  A_ACCOUNT_BLOCK_FRAUD = 'a:account:block_fraud',
  A_ACCOUNT_UNBLOCK = 'a:account:unblock',
  A_ACCOUNT_UNBLOCK_FRAUD = 'a:account:unblock_fraud',
  A_ACCOUNT_UNBLOCK_PB = 'a:account:unblock_pb',
  A_ACCOUNT_BLOCK_AREA_CUMPLIMIENTO = 'a:account:block_area:cumplimiento',
  A_ACCOUNT_BLOCK_AREA_OPERACIONES_ONBOARDING = 'a:account:block_area:operaciones_onboarding',
  A_ACCOUNT_BLOCK_AREA_OPERACIONES_PASIVO = 'a:account:block_area:operaciones_pasivo',
  A_ACCOUNT_BLOCK_AREA_MONITOREO_TRANSACCIONAL = 'a:account:block_area:monitoreo_transaccional',
  A_ACCOUNT_BLOCK_AREA_ACLARACIONES = 'a:account:block_area:aclaraciones',
  A_ACCOUNT_BLOCK_AREA_PERSONAL_BUSSINES_BANKER = 'a:account:block_area:personal_bussines_banker',
  A_ACCOUNT_BLOCK_AREA_PQRS = 'a:account:block_area:pqrs',
  A_ACCOUNT_GMF = 'a:account:gmf',
  A_ACCOUNT_SEND_CERT = 'a:account:send-cert',
  A_ACCOUNT_STATEMENT = 'a:account:statement',
  A_ACCOUNT_WITHDRAWAL = 'a:account:withdrawal',
  //Contract Actions
  A_CONTRACT_STATEMENT = 'a:contract:statement',
  A_CONTRACT_BLOCK = 'a:contract:block',
  A_CONTRACT_BLOCK_PB = 'a:contract:block_pb',
  A_CONTRACT_BLOCK_FRAUD = 'a:contract:block_fraud',
  A_CONTRACT_CANCEL = 'a:contract:cancel',
  A_CONTRACT_DOWNLOAD_CERT = 'a:contract:statement',
  //Onboarding Actions
  A_ONB_RESET = 'a:onb:reset',
  A_ONB_MANUAL_REVIEW = 'a:onb:manual-review',
  //Card Actions
  A_REWARDS_CASHBACK = 'a:rewards:cashback',
  A_REWARDS_WELCOME = 'a:rewards:welcome',
  A_CARD_BLOCK = 'a:card:block',
  A_CARD_UNFREEZE = 'a:card:unfreeze',
  A_CARD_REPLACE = 'a:card:replace',
  A_CARD_RESET = 'a:card:reset',

  //Business Search
  A_ACCESS_BUSINESS_INFO = 'access:bussines:info',
}
